import ProMembershipPrompt from '@jobseeker/feature-payment/components/ProMembershipPlanPopup';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import type {ProMembershipPromptType} from '@jobseeker/feature-payment/components/ProMembershipPlanPopup/types';

const ProMembershipPlanPopUp = (props: ProMembershipPromptType) => {
  const interceptor: any = useInterceptor();
  const {
    proMembership: {planPopUp},
  } = interceptor;
  return <ProMembershipPrompt planPopUp={planPopUp} {...props} />;
};

export default ProMembershipPlanPopUp;
